import { gql } from "@apollo/client";

export const SEND_TYPING = gql`
    mutation sendTyping($channelId: ID!, $typing: Boolean!){
        sendTyping(channelId: $channelId, typing: $typing) 
    }
`;
